import { defineStore } from "pinia";
import { HousingFinderInput } from "~/api";
import { showError } from "~/utils/handleAPIError";

export type InternalState = {
  initialInputs: HousingFinderInput | undefined;
};

export const useInitialFinderInputsStore = defineStore("FinderInputsStore", {
  state: (): InternalState => ({
    initialInputs: undefined,
  }),
  // NOTE: This store uses sessionStorage, not LocalForage
  actions: {
    /**
     * Load the state from sessionStorage or initialize it.
     * @param forceUpdate - If true, forces the state to be reloaded from the source.
     */
    async load(forceUpdate = false) {
      if (!forceUpdate && this.initialInputs) {
        return;
      }

      try {
        const cached = sessionStorage.getItem(this.$id);
        if (cached && !forceUpdate) {
          this.initialInputs = JSON.parse(cached);
        } else {
          console.log("getting fresh", this.$id);
          sessionStorage.setItem(this.$id, JSON.stringify(this.initialInputs));
        }
      } catch (error) {
        showError("Failed to load button state:", error);
      }
    },

    /**
     * Returns the HousingFinderInput object.
     * @returns HousingFinderInput
     */
    getFinderInputs(): HousingFinderInput | undefined {
      return this.initialInputs;
    },

    /**
     * Sets the initialInputs state.
     */
    setInitialInputs(inputs: HousingFinderInput) {
      // console.log("setting cache", inputs);
      this.initialInputs = inputs;
      sessionStorage.setItem(this.$id, JSON.stringify(this.initialInputs));
    },

    /**
     * Resets the initialInputs state and clears the sessionStorage.
     */
    resetInitialInputs() {
      this.initialInputs = undefined;
      sessionStorage.removeItem(this.$id);
    },
  },
});
